document.addEventListener('DOMContentLoaded', function() {
    const buttonLinks = document.querySelectorAll('a.button');
    buttonLinks.forEach(function(link) {
        if (link.href.includes('virtualtours')) {
            link.target = '_blank';
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const images = document.querySelectorAll('img');
    images.forEach(function(img) {
        const altText = img.getAttribute('alt');        
        if (altText && altText.trim() !== '') {
            img.setAttribute('title', altText);
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {

  setTimeout(function(){
  
    var button = document.getElementById('Deferred-Poster-Modal-26994781552685');
      
    button.click();
  
    setTimeout(function(){
      
      var videoSection = document.querySelector('.video-section');
      var video = videoSection.querySelector('video');
      video.muted = true;
      video.controls = false;
      video.play();
      
    },250)

  },500)

});